import React from 'react';
import { LoginFooter } from '../../components/common/CommonViews';
import '../../asset/css/login.css';

// 인증 화면 공용 틀(IMP-475 U-53) — 로그인 화면 디자인(배경·브랜드 패널·카드·폼 패널)을 한 곳에 둔다.
// 로그인/비밀번호 찾기/재설정 화면이 같은 틀을 쓴다. 폼 내용·동작은 각 화면이 children 으로 그대로 가진다.

export const AlertIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6"/>
        <path d="M12 7v6M12 16.5v.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
);

// topRight: 폼 패널 우상단 슬롯(언어 선택 등). title/description 이 없으면 머리글을 그리지 않는다.
const AuthShell = ({ title, description, topRight = null, children }) => (
    <div className="rg-login-bg">
    <div className="rg-login-shell">
        {/* LEFT: brand panel */}
        <section className="rg-login-brand" aria-hidden="true">
            <div className="rg-login-logo">
                <span className="rg-login-logo-mark">
                    <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                        <path d="M12 2.5l7.5 4v5c0 4.6-3.2 8.2-7.5 9.5C7.7 19.7 4.5 16.1 4.5 11.5v-5L12 2.5z" stroke="#fff" strokeWidth="1.6"/>
                        <path d="M8 12l2.5 2.5L16 9" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
                <span>RAYGuard</span>
            </div>

            <div className="rg-login-brand-copy">
                <h2>Securing Every Moment<br/>of Medical Device Operations.</h2>
                <p>Installation · Service · Warranty · License — manage distributed device data on one trusted platform.</p>
                <svg className="rg-login-pulse" viewBox="0 0 320 40" preserveAspectRatio="none">
                    <path d="M0 20 H90 l8 -14 l10 28 l9 -22 l8 8 H320"/>
                </svg>
            </div>

            <div className="rg-login-stats">
                <div><b>19</b>Languages</div>
                <div><b>RAY</b>Medical Group</div>
            </div>
        </section>

        {/* RIGHT: form panel */}
        <section className="rg-login-panel">
            {topRight}

            {title && (
                <div className="rg-login-head">
                    <h1>{title}</h1>
                    {description && <p>{description}</p>}
                </div>
            )}

            {children}

            <LoginFooter />
        </section>
    </div>
    </div>
);

export default AuthShell;
